import {AbstractControl, ValidationErrors} from '@angular/forms';
import {dateTimeInputToDate} from '@tisa-group/cdk/date-time';

export const futureDatetime = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  const value = dateTimeInputToDate(control.value);

  if (value && new Date(value) < new Date()) {
    return {futureDatetime: true};
  }

  return null;
};
